import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../constants';
import { sortSubcategories, removeHtmlFromSubcategories, removeHtmlFromText } from '../../../services/Helpers';
import LetterCategoriesBox from './LetterCategoriesBox';
import EditIcon from '../../../imgs/edit-icon.svg';
import DeletedIcon from '../../../imgs/deleted-icon.svg';

const LargeResult = ({
  letters,
  categories,
  onCategoryClick,
  selectedCategory,
  subcategories,
  user,
  onDeleteCategory,
  onEditCategory,
  onDeleteConsultation
}) => (
  <div className="results-wrapper-large">
    <div className="results-container">
      <div className="panel-categories">
        { letters.map(letter =>
          <LetterCategoriesBox
            key={ letter }
            letter={ letter }
            categories={ categories[letter] }
            onCategoryClick={ onCategoryClick }
            selectedCategory={ selectedCategory }
          />
        )}
      </div>
      { selectedCategory &&
        <div className="panel-catresults">
          <p className="cat-title">{ selectedCategory.title }
            { user && user.role === 'admin' &&
              <div style={{ float: 'right' }}>
                <button className='btn btn-remove-cat' onClick={ onDeleteCategory }>
                  <img src={ DeletedIcon } alt="icon" />
                </button>
                <button className='btn btn-remove-cat' onClick={ onEditCategory }>
                  <img src={ EditIcon } alt="icon" />
                </button>
              </div>
            }
          </p>
          { subcategories ?
            (sortSubcategories(removeHtmlFromSubcategories(subcategories)).map(subcategory =>
              <div
                key={ subcategory.id }
                className='admin-consultation-action-container'
              >
                <Link
                  to={ user && user.role !== 'admin' ?
                    `${ ROUTES.CONSULTATION_DETAILS.replace('/:id', '') }/${ subcategory.id }` :
                    `${ ROUTES.CONSULT_EDIT.replace('/:id', '') }/${ subcategory.id }`
                  }
                  className='cat-result'
                >
                  { removeHtmlFromText(subcategory.subcategory) }
                </Link>
                { user && user.role === 'admin' &&
                  <button className='btn btn-remove-cat' onClick={ () => onDeleteConsultation(subcategory.id, selectedCategory.id) }>
                    <img src={ DeletedIcon } alt="icon" />
                  </button>
                }
              </div>
            )) :
            (selectedCategory.subcategories && sortSubcategories(removeHtmlFromSubcategories(selectedCategory.subcategories)).map(subcategory =>
              <div
                key={ subcategory.id }
                className='admin-consultation-action-container'
              >
                <Link
                  key={ subcategory.id }
                  to={ user && user.role !== 'admin' ?
                    `${ ROUTES.CONSULTATION_DETAILS.replace('/:id', '') }/${ subcategory.id }` :
                    `${ ROUTES.CONSULT_EDIT.replace('/:id', '') }/${ subcategory.id }`
                  }
                  className='cat-result'
                >
                  { removeHtmlFromText(subcategory.subcategory) }
                </Link>
                { user && user.role === 'admin' &&
                  <button className='btn btn-remove-cat' onClick={ () => onDeleteConsultation(subcategory.id, selectedCategory.id) }>
                    <img src={ DeletedIcon } alt="icon" />
                  </button>
                }
              </div>
            ))
          }
        </div>
      }
    </div>
  </div>
);

export default LargeResult;